<template>
  <div>
    <!-- 검색 부분 -->

    <component v-if="tab.search" :is="tab.search" @search="onClickCustomSearch" />
    <search-nav v-else @handleSearch="() => onClickSearch(nav)">
      <search-select-company-name v-model="nav.companyName" @input="onClickSearch(nav)" />
      <search-keyword label="키워드" v-model="nav.keyword" @enter="onClickSearch(nav)"/>
    </search-nav>

    <!-- 버튼 리스트 -->
    <slot name="top-buttons">
      <div class="flex mb-4 justify-between items-center w-full">
        <!-- 왼쪽 -->
        <div class="flex items-center">
          <div v-if="useTools.total" class="mr-2 pl-2 xl:pl-0" style="font-size: 18px">
            <span class="mr-2" style="font-weight: 700">표시된 문서 :</span>
            <span>{{ total }}건</span>
          </div>
        </div>

        <!-- 오른쪽 -->
        <div class="flex gap-4 text-right px-4 xl:px-0">
          <vs-button v-if="useTools.showExcelListDownload" class="" color="secondary" @click="onClickShowExcelListDownload"> List Excel 내려받기 </vs-button>
          <vs-button v-if="useTools.new" class="" color="secondary" @click="onClickNew"> 신규작성 </vs-button>
        </div>
      </div>
    </slot>

    <!-- 목록 -->
    <vs-card>
      <vs-select class="mb-4" v-model="perPage" autocomplete @input="onClickSearch(nav)">
        <vs-select-item v-for="per in [50, 75, 100, 125, 150]" :key="per" :value="per" :text="`${per}개씩 보기`" />
      </vs-select>

      <vs-table stripe ref="table" :sst="true" :data="tableList" noDataText="" @sort="onClickSort" @selected="onClickDetail">
        <template slot="thead">
          <vs-th v-for="(head, headIndex) in options.getHead()" style="min-width: 130px" :style="head.style" :class="head.class" :key="headIndex" :sort-key="head.isNoSort ? null : head.key">
            <span class="w-full text-center">{{ head.name }}</span>
          </vs-th>
        </template>

        <template>
          <vs-tr v-if="tableList.length === 0">
            <vs-td colspan="100">
              <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                <feather-icon icon="AlertTriangleIcon" class="mr-2" />
                표시할 데이터가 없습니다.
              </div>
            </vs-td>
          </vs-tr>
          <vs-tr v-else v-for="(row, rowIndex) in tableList" :data="row" :key="rowIndex">
            <vs-td v-for="(col, colIndex) in options.getHead()" :key="colIndex" style="text-align: center" :style="getCol(rowIndex, colIndex, row).style">{{ getCol(rowIndex, colIndex, row).value }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="onClickPage"></k-pagination>
        </div>
      </div>
    </vs-card>

    <!-- 팝업 -->
    <popup-excel-download v-if="useTools.showExcelListDownload" :showHeader="false" :col-num="options.getHead().length" v-model="popupController.showExcelList" :list="popupController.excelList" :title="`${tab.field_name} 목록`" />
  </div>
</template>

<script>
import moment from "moment";
import includeSinglePage from "@/views/fields/single-page/include";
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemProject from "@/components/nav/SearchNavItemProject";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemField from "@/components/nav/SearchNavItemField";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import PopupApprovalProcess from "@/views/approval/PopupApprovalProcess.vue";
import SearchCompanyIds from "@/views/list/components/SearchCompanyIds.vue";
import SearchSelectCompanyName from "@/views/list/components/SearchSelectCompanyName.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
export default {
  name: "FieldList",
  components: {
    SearchKeyword,
    SearchSelectCompanyName,
    SearchCompanyIds,
    PopupApprovalProcess,
    PopupExcelDownload,
    SearchNavItemField,
    SearchNavItemKeyword,
    KPagination,
    SearchNavItemProject,
    SearchNav,
  },
  props: {
    fieldCode: String,
    tab: Object,
    projectId: [String, Number],
  },
  data() {
    return {
      // 검색 네비게이션
      nav: {
        keyword: "",
        companyName: "",
      },
      sort: {
        key: "",
        order: "",
      },
      list: [],
      total: 0,
      currentPage: 1,
      perPage: 50,
      lastPage: 1,

      params: {},
      popupController: {
        showExcelList: false,
        excelList: [],
      },
    };
  },
  computed: {
    field() {
      return {
        fieldCode: this.fieldCode,
        pageType: this.tab.pageType,
        projectId: this.projectId,
      };
    },
    options() {
      return this.tab ? this.tab.options : {};
    },
    tableList() {
      return this.list;
    },
    companyList() {
      // 해당 변수를 사용하기 위해서는 loadCompanyList()를 먼저 실행해야 합니다.
      return this.$store.state.company.companyList;
    },
    useTools() {
      // 기본값
      const tools = {
        total: false,
        new: true,
        showExcelListDownload: true,
      };

      if (this.options.useDocumentCount) {
        tools.total = this.options.useDocumentCount(this.field, this.tab);
      }

      if (this.options.useNewButton) {
        tools.new = this.options.useNewButton(this.field, this.tab);
      }

      if (tools.new) {
        if (this.isEditable) {
          tools.new = true;
        } else {
          tools.new = false;
        }
      }

      if (this.options.useshowExcelListDownload) {
        tools.showExcelListDownload = this.options.useshowExcelListDownload(this.field, this.tab);
      }

      return tools;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
    companyTree() {
      const _data = this.$store.state.company.companyTree;
      if (_data.length && 0 < _data.length) return _data;
      else return [];
    },
  },
  async created() {
    // 로그 기록 - 초기 URL 상태
    console.log('초기 URL:', window.location.href);

    // 항상 URL에서 페이지 번호를 먼저 가져옵니다
    this.syncPageFromUrl();
    console.log('URL에서 읽은 페이지:', this.nav);

    // 나머지 작업을 진행합니다
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
    await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId });

    // 컴포넌트 생성 시 호출
    if (this.currentPage > 1) {
      // 페이지 정보가 URL에 있으면 즉시 해당 페이지 데이터 로드 (URL 업데이트 없이)
      await this.loadFieldList(false);
    } else {
      await this.loadFieldList(false); // URL 업데이트 없이 데이터만 로드
    }
  },
  mounted() {
    // URL에서 페이지 번호를 가져왔으므로 loadFieldList 호출은
    // created 훅으로 이동했습니다

    if (includeSinglePage.list.loadCompanyList) {
      this.loadCompanyList();
    }
  },
  methods: {
    // ============ 클릭 이벤트 ============
    onClickNew() {
      this.$emit("moveCreate");
    },
    onClickSort(key, order) {
      if (!key) return;
      this.sort.key = key;
      this.sort.order = order;
      this.loadFieldList();
    },
    onClickDetail(data) {
      const fieldId = data.id;
      this.$emit("moveUpdate", fieldId, {
        currentPage: this.currentPage,
        companyName: this.nav.companyName,
        keyword: this.nav.keyword,
      });
    },
    onClickSearch(nav) {
      this.nav = nav;
      const find = this.companyTree.find((company) => company.descendant.com_name === this.nav.companyName);
      const parentCompanyId = find ? find.descendant.id : 0;
      const params = {};
      if (this.nav.keyword) {
        params.keyword = this.nav.keyword;
      }
      if (parentCompanyId) {
        params.parentCompanyId = parentCompanyId;
      }
      this.params = params;
      this.currentPage = 1;
      this.loadFieldList();
    },
    onClickCustomSearch(data) {
      if (this.options.loadFieldList) {
        const params = this.options.loadFieldList(data);
        this.params = params;
      }
      // 커스텀 검색(Search.vue)이 부서명(companyName)/키워드를 넘겨주는 경우,
      // 기본 검색과 동일하게 URL(cName, keyword) 및 상세 진입 시 검색 상태를 유지한다
      if (data && data.companyName !== undefined) {
        this.nav = { ...this.nav, companyName: data.companyName || "", keyword: data.keyword || "" };
      }
      this.currentPage = 1;
      this.loadFieldList();
    },
    onClickPage(page) {
      this.currentPage = page;
      // URL 쿼리 파라미터 업데이트
      this.updateUrlParam('pg', page);
      this.loadFieldList(false); // URL 업데이트 없이 데이터만 로드
    },
    onClickShowExcelListDownload() {
      this.loadFieldListAll((_list) => {
        const head = this.options.getHead().map((item) => item.name);
        const list = [];
        for (let rowIndex = 0, row; (row = _list[rowIndex]); rowIndex++) {
          const item = [];
          for (let colIndex = 0; (this.options.getHead()[colIndex]); colIndex++) {
            item.push(this.getCol(rowIndex, colIndex, row).value);
          }
          list.push(item);
        }

        this.popupController.excelList = [head, ...list];
        this.popupController.showExcelList = true;
      });
    },

    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput() {
      this.onClickSearch();
    },

    getCol(rowIndex, colIndex, value) {
      const options = this.options;
      if (options) {
        const func = {
          // object
          no: this.getNo(rowIndex),
          meta: this.getMeta(value),
          // function
          comma: this.comma,
          date: this.convertDate,
          totalNumDevices: this.totalNumDevices,
          getCompanyName: this.getCompanyName,
          getCompanyNames: this.getCompanyNames,
          onNameBlur: this.onNameBlur,
          getContent: this.getContent,
          getContentTargetList: this.getContentTargetList,
          getContentRiskList: this.getContentRiskList,
          getContentStringList: this.getContentStringList,
        };
        const col = options.getCol(colIndex, value, func);
        if (typeof col === "string" || typeof col === "number") {
          return { type: "text", value: col, style: {} };
        }
        if (!col) return {
          style: {},
          type: "text",
          value: "",
        };
        return col;
      }
      return {
        style: {},
        type: "text",
        value: "",
      };
    },
    getNo(index) {
      const total = Number(`${this.total}`);
      const currentPage = Number(`${this.currentPage}`);
      const perPage = this.options.getPerPage ? Number(`${this.options.getPerPage(this.tab)}`) : 10; // 기본값 10
      return total - (currentPage * perPage) + (perPage - index);
    },

    getMeta(row) {
      try {
        if (typeof row.meta === "string") {
          return JSON.parse(row.meta);
        }
        return row.meta;
      } catch (e) {
        return {};
      }
    },

    async loadFieldList(updateUrlAfterLoad = true) {
      const projectId = this.projectId;
      const page = this.currentPage;
      const perPage = this.perPage;
      const code = this.fieldCode;
      const params = this.params;

      const options = {
        projectId,
        code, page,
        perPage,
        showAll: true,
        ...params
      };

      if (this.sort.key && this.sort.order) {
        options.order_by = `${this.sort.key}`.replaceAll("body.", "");
        options.order_direction = this.sort.order;
      }

      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }

      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);

      const fieldListInfo = this.$store.state.project.fieldListInfo;
      this.list = fieldListInfo.data;

      // 페이지 정보 설정 - 현재 페이지 정보는 URL에서 가져온 것을 우선시함
      const originalPage = this.currentPage;
      if (fieldListInfo.current_page !== originalPage && originalPage > 0 && originalPage <= fieldListInfo.last_page) {
        // URL에서 가져온 페이지가 유효하면 그대로 유지
        this.lastPage = fieldListInfo.last_page;
        this.total = fieldListInfo.total_count;
      } else {
        // API에서 반환한 페이지 정보 사용
        this.currentPage = fieldListInfo.current_page;
        this.lastPage = fieldListInfo.last_page;
        this.total = fieldListInfo.total_count;
      }

      // URL 파라미터 업데이트 (필요한 경우에만)
      if (updateUrlAfterLoad) {
        this.updateUrlParam('pg', this.currentPage);
        this.updateUrlParam('cName', this.nav.companyName);
        this.updateUrlParam('keyword', this.nav.keyword);
      }
    },

    loadFieldListAll(callback) {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 10000;
      const code = this.fieldCode;
      const params = this.params;

      const options = {
        projectId,
        code,
        page,
        perPage,
        showAll: true,
        ...params };
      this.$store.dispatch("project/LOAD_FIELD_LIST", options).then((fieldListInfo) => {
        const list = fieldListInfo.data;
        callback(list);
      });
    },

    async loadCompanyList() {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 10000;
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        projectId,
      });
    },

    // ===============  func ===============
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    convertDate(data, format = "YYYY-MM-DD") {
      if (data === "") return "";
      return moment(data).format(format);
    },
    totalNumDevices(data) {
      // 오브젝트의 value를 전부 합한 값을 리턴
      let sum = 0;
      for (const key in data) {
        sum += data[key];
      }
      return sum;
    },
    // 해당 함수를 사용하기 위해서는 loadCompanyList()를 먼저 실행해야 합니다.
    getCompanyName(comId) {
      for (const com of this.companyList) {
        if (com.id === comId) {
          return com.com_name;
        }
      }
    },
    getCompanyNames(companies) {
      return companies ? companies.map((item) => item.com_name).join(", ") : "-";
    },
    onNameBlur(name) {
      const length = name.length;
      if (2 < length) {
        const first = name[0];
        const last = name[name.length - 1];
        let star = "";
        for (let index = 0; index < length - 2; index++) {
          star += "*";
        }
        name = first + star + last;
      } else if (length === 2) {
        const first = name[0];
        name = `${first}*`;
      }
      return name;
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content;
      }
    },
    getContentTargetList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentRiskList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.input_3)) {
          result += `${data.input_3},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentStringList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    // URL 쿼리 파라미터 업데이트 함수
    updateUrlParam(key, value) {
      const url = new URL(window.location.href);
      const urlParams = new URLSearchParams(url.search);

      urlParams.set(key, value);
      url.search = urlParams.toString();

      // 히스토리 업데이트 (페이지 새로고침 없이)
      window.history.pushState({}, '', url.toString());
    },
    // URL에서 페이지 번호 가져오기 (개선된 버전)
    syncPageFromUrl() {
      try {
        const url = new URL(window.location.href);
        const pageParam = url.searchParams.get('pg');
        const companyNameParam = url.searchParams.get('cName');
        const keywordParam = url.searchParams.get('keyword');
        console.log('URL에서 읽은 pg 파라미터:', pageParam, companyNameParam, keywordParam);

        if (pageParam && !isNaN(parseInt(pageParam))) {
          const pageNum = parseInt(pageParam);
          if (pageNum > 0) { // 유효한 페이지 번호만 설정
            this.currentPage = pageNum;
            console.log('페이지 번호 설정됨:', this.currentPage);
          }
        }

        const nav = {...nav}
        if (companyNameParam) {
          nav.companyName = companyNameParam;
        }

        if (keywordParam) {
          nav.keyword = keywordParam;
        }

        this.nav = nav

      } catch (e) {
        console.error('URL 파라미터 읽기 오류:', e);
      }
    },
  },
};
</script>

<style scoped></style>
